import countries from "i18n-iso-countries"
import countriesEn from "i18n-iso-countries/langs/en.json"
import countriesFr from "i18n-iso-countries/langs/fr.json"
import * as React from "react"
import { useTranslation } from "react-i18next"

import Details from "Catalog/Edit/shared/components/Details"
import StatefulField from "shared/components/StatefulField"
import { INutrition } from "shared/hubrise/models"

countries.registerLocale(countriesEn)
countries.registerLocale(countriesFr)

const countryOptions = (lang: string): Array<{ label: string; value: string }> =>
  Object.entries(countries.getNames(lang))
    .map(([code, name]) => ({ label: name, value: code }))
    .sort((a, b) => a.label.localeCompare(b.label))

interface ProducerProps {
  nutrition: INutrition | null
  updateNutrition: (patch: Partial<INutrition>) => void
}

const Producer = ({ nutrition, updateNutrition }: ProducerProps): JSX.Element => {
  const { t, i18n } = useTranslation()

  return (
    <>
      <Details.SplitHalf>
        <StatefulField.Input
          name="nutrition-producer-name"
          initialValue={nutrition?.producer_name ?? ""}
          label={t("nutrition.component.producer.name")}
          withMargin
          onChange={(value) => updateNutrition({ producer_name: value || null })}
        />

        <StatefulField.Input
          name="nutrition-producer-brand"
          initialValue={nutrition?.producer_brand ?? ""}
          label={t("nutrition.component.producer.brand")}
          withMargin
          onChange={(value) => updateNutrition({ producer_brand: value || null })}
        />
      </Details.SplitHalf>

      <StatefulField.Input
        name="nutrition-producer-address"
        initialValue={nutrition?.producer_address ?? ""}
        label={t("nutrition.component.producer.address")}
        withMargin
        onChange={(value) => updateNutrition({ producer_address: value || null })}
      />

      <StatefulField.Select
        name="nutrition-country-of-origin"
        initialValue={nutrition?.country_of_origin != null ? [nutrition.country_of_origin] : []}
        label={t("nutrition.component.producer.country_of_origin")}
        withMargin
        options={countryOptions(i18n.language)}
        onChange={(values) => updateNutrition({ country_of_origin: values[0] || null })}
        withClearValue={true}
      />
    </>
  )
}

export default Producer
